<div class="mt-4 mb-6">
  <h2>Admin</h2>

  <input placeholder="Search for a page by name" class="form-control mb-4"
         [ngbTypeahead]="handlePageTypeahead"
         [inputFormatter]="pageTypeaheadFormatter"
         [resultFormatter]="pageTypeaheadFormatter"
         [editable]="false"
         (selectItem)="navigateToPage($event.item);$event.preventDefault();">

  <div class="row">
    <div class="col-12 col-lg-6 pb-3" *ngFor="let page of visiblePageItems">
      <div class="card h-100">
        <a class="card-body d-block" [routerLink]="page.link">
          <h5 class="card-title text-dark font-weight-bold mb-0">
            {{ page.title }}
          </h5>
          <p class="card-text text-muted mt-2" *ngIf="page.description">
            {{ page.description }}
          </p>
        </a>
      </div>
    </div>
  </div>
</div>
